interface IconProps {
  color?: string;
  className?: string;
}

export default function SignIcon({
  color = "#8E929E",
  className = "",
}: IconProps) {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_6675_34798)">
        <path
          d="M8.00001 3.91064C6.54407 3.91064 5.35889 5.09002 5.35889 6.5502C5.35889 7.69894 6.09452 8.66388 7.12134 9.02637V14.1268C7.12134 14.6118 7.5147 15.0049 8.00001 15.0049C8.48532 15.0049 8.87868 14.6118 8.87868 14.1268V9.02637C9.90039 8.66388 10.6411 7.69894 10.6411 6.5502C10.6411 5.09512 9.46106 3.91064 8.00001 3.91064ZM8.00001 7.43855C7.50448 7.43855 7.10601 7.04032 7.10601 6.54509C7.10601 6.04985 7.50448 5.65162 8.00001 5.65162C8.49554 5.65162 8.89401 6.04985 8.89401 6.54509C8.89401 7.04032 8.49554 7.43855 8.00001 7.43855Z"
          fill={color}
        />
        <path
          d="M11.7395 0.0512697C11.4125 -0.0916847 11.0396 0.0614807 10.9017 0.383128C10.7637 0.704776 10.9119 1.08258 11.2337 1.22043C13.3589 2.14453 14.728 4.23269 14.728 6.54548C14.728 8.85828 13.3538 10.9464 11.2337 11.8654C10.9119 12.0084 10.7637 12.3811 10.9017 12.7027C11.009 12.9427 11.2388 13.0856 11.4892 13.0856C11.576 13.0856 11.6577 13.0703 11.7446 13.0346C14.3346 11.9114 16.0102 9.35862 16.0102 6.54038C16.0102 3.72213 14.3295 1.17959 11.7395 0.0512697Z"
          fill={color}
        />
        <path
          d="M11.0856 9.28686C10.8097 9.5064 10.7637 9.90463 10.9834 10.1854C11.1111 10.3437 11.295 10.4254 11.484 10.4254C11.622 10.4254 11.765 10.3794 11.8825 10.2875C13.037 9.37365 13.696 8.01048 13.696 6.5452C13.696 5.07991 13.037 3.71674 11.8825 2.80286C11.6066 2.58332 11.2031 2.62927 10.9834 2.90497C10.7637 3.18066 10.8097 3.584 11.0856 3.80354C11.9336 4.47236 12.4189 5.47304 12.4189 6.5452C12.4189 7.61735 11.9336 8.61804 11.0856 9.28686Z"
          fill={color}
        />
        <path
          d="M4.91443 3.80354C5.19029 3.584 5.23627 3.18577 5.0166 2.90497C4.79693 2.62927 4.39846 2.58332 4.11749 2.80286C2.96296 3.71674 2.30396 5.07991 2.30396 6.5452C2.30396 8.01048 2.96807 9.37365 4.11749 10.2875C4.23499 10.3794 4.37292 10.4254 4.51085 10.4254C4.69987 10.4254 4.88378 10.3437 5.01149 10.1854C5.23116 9.90973 5.18518 9.5064 4.90421 9.28686C4.05619 8.61804 3.57088 7.61735 3.57088 6.5452C3.57088 5.47304 4.05619 4.47236 4.90421 3.80354H4.91443Z"
          fill={color}
        />
        <path
          d="M5.10345 0.382915C4.96041 0.0612672 4.58748 -0.0867927 4.26565 0.0510562C1.67561 1.17937 0 3.72703 0 6.54527C0 9.36351 1.67561 11.9112 4.26565 13.0395C4.34738 13.0752 4.43423 13.0905 4.52107 13.0905C4.76628 13.0905 5.00128 12.9476 5.10856 12.7076C5.2516 12.386 5.09834 12.0082 4.7765 11.8703C2.65134 10.9462 1.28225 8.85807 1.28225 6.55038C1.28225 4.24268 2.65134 2.14432 4.77139 1.22532C5.09323 1.08237 5.24138 0.709667 5.10345 0.38802V0.382915Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_6675_34798">
          <rect width="16" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
